import React                            from 'react';
import { Observe }                      from 'rewire-core';
import {
  WithStyle,
}                                       from 'rewire-ui';
import { Theme }                        from '@material-ui/core/styles';
import { makeStyles, withStyles }       from '../utility/styles';
import archiveDeleteGroupDialogModel    from './ArchiveDeleteGroupDialogModel';
import ArchiveDeleteDialog              from './ArchiveDeleteDialog';

const contentStyles = (_theme: Theme) => ({
  list: {
    listStylePosition: 'inside',
    textAlign: 'left',
    display: 'inline-block',
  },
});

const useContentStyles = makeStyles(contentStyles);

export const ArchiveDeleteGroupConfirmationContent = () => {
  const classes = useContentStyles();

  return <Observe render={() => {
    const group       = archiveDeleteGroupDialogModel.name;
    const date        = archiveDeleteGroupDialogModel.endDateString;
    const taskDisplay = archiveDeleteGroupDialogModel.taskDisplay;
    return (
      < >
      <div>
        <div>
          All transactions for: {group}<br />
          As of: {date} will be deleted from WorkSight for:
        </div>
        <ul className={classes.list}>
          <li>Timecards</li>
          <li>Jobs</li>
        </ul>
        <div>
          Enter Group Name to Confirm {taskDisplay}:
        </div>
      </div>
      </>
    );
  }} />;
};

const styles = (_theme: Theme) => ({
});

interface IArchiveDeleteGroupDialogProps {
}

type ArchiveDeleteGroupDialogProps = WithStyle<ReturnType<typeof styles>, IArchiveDeleteGroupDialogProps>;

class ArchiveDeleteGroupDialog extends React.PureComponent<ArchiveDeleteGroupDialogProps> {
  constructor(props: ArchiveDeleteGroupDialogProps) {
    super(props);
  }

  render() {
    return <Observe render={() => (
      <ArchiveDeleteDialog model={archiveDeleteGroupDialogModel} />
    )} />;
  }
}

export default withStyles<IArchiveDeleteGroupDialogProps>(styles, ArchiveDeleteGroupDialog);
